<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="17.2" height="17.2" viewBox="0 0 17.2 17.2">
    <g transform="translate(0.6 0.454)">
      <circle class="a" cx="8" cy="8" r="8" transform="translate(0 0.146)"/>
      <line class="a" x1="4" transform="translate(12 8.146)"/>
      <line class="a" x1="4" transform="translate(0 8.146)"/>
      <line class="a" y1="4" transform="translate(8 0.146)"/>
      <line class="a" y1="4" transform="translate(8 12.146)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "StrategyIcon"
}
</script>

<style scoped>
.a {
  fill: none;
  stroke: #8ea2a8;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.2px;
}
</style>
